import { RotateCw, TriangleAlert } from 'lucide-react';
import { friendlyMessage } from '@/lib/api/api-error';
import { Button } from './button';
import { EmptyState } from './empty-state';

export function ErrorState({
  error,
  onRetry,
  title = 'We couldn’t load this',
  compact,
}: {
  error: unknown;
  onRetry?: () => void;
  title?: string;
  compact?: boolean;
}) {
  return (
    <div role="alert">
      <EmptyState
        icon={TriangleAlert}
        title={title}
        description={friendlyMessage(error)}
        compact={compact}
        action={
          onRetry && (
            <Button variant="secondary" size="sm" onClick={onRetry}>
              <RotateCw aria-hidden /> Try again
            </Button>
          )
        }
      />
    </div>
  );
}
